import GameActions from "./gameActions"
import SettingsActions from "./settingsActions"

const Actions = Object.assign({}, GameActions, SettingsActions )

export default Actions



/** WEBPACK FOOTER **
 ** ./src/app/redux/actions/index.js
 **/